module.exports = __webpack_public_path__ + "static/shopping-19715275235e1e8516fa17baa7173da3.jpg";